export function Tabs({ items, value, onChange, label = "内容分区" }) {
  return (
    <div className="ui-tabs" role="tablist" aria-label={label}>
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <button
            type="button"
            role="tab"
            aria-selected={value === item.value}
            key={item.value}
            className={value === item.value ? "is-active" : ""}
            onClick={() => onChange(item.value)}
          >
            {Icon ? <Icon size={16} /> : null}
            <span>{item.label}</span>
            {item.count !== undefined ? <small>{item.count}</small> : null}
          </button>
        );
      })}
    </div>
  );
}
